import { api } from '../../api'
import { CommercialSupplier, User } from '../../types'

export type CreateCommercialSupplierPayload = {
  name: string
  surname: string
  userName: string
  country?: string
  email: string
  cellphone?: string
  supplierIds: number[]
  password: string
}

export type UpdateCommercialSupplierPayload = {
  name?: string
  surname?: string
  country?: string
  email?: string
  cellphone?: string
  supplierIds?: number[]
}

export type CommercialSuppliersListResponse = {
  commercialSuppliers: CommercialSupplier[] | CommercialSuppliersPaginated
}

type CommercialSuppliersPaginated = {
  data: CommercialSupplier[]
  total: number
  page: number
  lastPage: number
}

const normalizeList = (raw: CommercialSupplier[] | CommercialSuppliersPaginated) => {
  if (Array.isArray(raw)) {
    return { commercialSuppliers: raw, total: raw.length }
  }
  return { commercialSuppliers: raw.data, total: raw.total }
}

const getCommercialSuppliers = async () => {
  const response = await api.get<CommercialSuppliersListResponse>('/commercial-suppliers')
  return normalizeList(response.data.commercialSuppliers)
}

export type CommercialSupplierDetailResponse = {
  commercialSupplier: CommercialSupplier
  linkedUser: User | null
}

const getCommercialSupplierById = async (id: number) => {
  const response = await api.get<CommercialSupplierDetailResponse>(`/commercial-suppliers/${id}`)
  return response.data
}

type CreateCommercialSupplierResponse = { commercialSupplier: CommercialSupplier }
type UpdateCommercialSupplierResponse = { commercialSupplier: CommercialSupplier }

const createCommercialSupplier = async (payload: CreateCommercialSupplierPayload) => {
  const response = await api.post<CreateCommercialSupplierResponse>('/commercial-suppliers', {
    commercialSupplier: payload,
  })
  return response.data.commercialSupplier
}

const updateCommercialSupplier = async (id: number, payload: UpdateCommercialSupplierPayload) => {
  const response = await api.put<UpdateCommercialSupplierResponse>(`/commercial-suppliers/${id}`, {
    commercialSupplier: payload,
  })
  return response.data.commercialSupplier
}

const CommercialSuppliersApi = {
  getCommercialSuppliers,
  getCommercialSupplierById,
  createCommercialSupplier,
  updateCommercialSupplier,
}

export default CommercialSuppliersApi
